import PageNotFound from '@members/pg-not-found/PageNotFound';

export default function Custom404() {
  return <PageNotFound />;
}
